import * as React from 'react';
import { useLiveOperation } from '../../userHooks'
import './index.css'
import liveInstance from "../../liveController/createLiveInstance";
import ShareIcon from '@mui/icons-material/Share';
import PeopleIcon from '@mui/icons-material/People';
import ChatIcon from '@mui/icons-material/Chat';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from "@mui/icons-material/MicOff";
import SendIcon from '@mui/icons-material/Send'
import { Input, Badge, IconButton } from '@mui/material'
import { useLiveBroadcast } from "../../userHooks";
import UserInfoPanel from "./UserInfoPanel";
import CloseIcon from '@mui/icons-material/Close';
import LiveShareModal from "./LiveShareModal";
import { useVolumes } from '../../userHooks'
import { useSelector } from "react-redux";
import { getLiveInfo } from "../../slices/liveSlice";
import CallEndIcon from '@mui/icons-material/CallEnd';
import Toast from "../_ui/Toast";

const {
    useSelfInfo,
    useUserList,
    useLiveAction,
    useRTCEventCallback
} = liveInstance

const DefaultSpaceLiveModeLayout = () => {
    const { liveExit } = useLiveOperation()
    const liveInfo = useSelector(getLiveInfo)
    const currentUserList = useUserList()
    const [showGreetBtn, setShowGreetBtn] = React.useState(true)
    const greetMsgRef = React.createRef()
    const liveBroadcast = useLiveBroadcast()
    const [selfInfo, setSelfInfo] = useSelfInfo()
    const [showUserInfoPanel, setShowUserInfoPanel] = React.useState(false)
    const { kick, toggleMicro, forbidMicro } = useLiveAction()
    const userVolumes = useVolumes()
    const [isTalking, setIsTalking] = React.useState(false)
    const [showShareModal, setShowShareModal] = React.useState(false)
    
    React.useEffect(() => {
        if(!selfInfo) return
        if(!userVolumes.length) return
        const volumeItem = userVolumes.find(item => selfInfo.id === item.userId)
        const isTalking = !!(volumeItem && volumeItem.audioVolume >= 10)
        setIsTalking(isTalking)
    }, [userVolumes])
    
    useRTCEventCallback("joined", () => {
        console.log('rtc -- joined')
    })
    
    useRTCEventCallback("error", (error) => {
        console.log('rtc -- error: ', error.message)
    })
    
    const handleShareLive = () => {
        setShowShareModal(true)
    }
    
    const handleClose = () => {
        liveExit().then(() => {
            Toast.success('退出带看')
        })
    }
    
    return <div className="default__live">
        <div className="gui__top">
            <div className="gui__top--bar">
                <IconButton className="close btn" sx={{color: 'white'}} onClick={handleClose}><CloseIcon /></IconButton>
                <IconButton className="title btn" sx={{color: 'white', fontSize: '16px'}}>如视开发者中心示例--live态</IconButton>
                <IconButton className="share btn" sx={{color: 'white'}} onClick={() => handleShareLive()}><ShareIcon/></IconButton>
            </div>
        </div>
        <div className="gui__overlay">
            <div className="scene-overlay">
                <LiveShareModal
                    open={showShareModal}
                    onClose={() => setShowShareModal(false)}
                    shareConfig={{ shareLink: `${window.location.href.split('?')[0]}?userRole=audience&roomCode=${liveInfo.roomCode}&enterLive=true` }}
                />
                {
                    showUserInfoPanel && <div className="overlay-modal">
                        <IconButton className="icon-close" onClick={() => setShowUserInfoPanel(false)}><CloseIcon/></IconButton>
                        <UserInfoPanel
                            list={currentUserList}
                            selfInfo={selfInfo}
                            volumeLists={userVolumes}
                            onForbiddenMicro={(userId) => forbidMicro('CLOSE', userId)}
                            onKickUser={(userId) => kick(userId)}
                            onNickNameChange={(newNickName) => setSelfInfo({'nickname': newNickName})}
                        />
                    </div>
                }
            </div>
        </div>
        <div className="gui__bottom">
            <div className='controls'>
                <div className='collapsible-list'>
                    <div className='collapsible-item'>
                        <IconButton sx={{color: 'white'}} className="members" onClick={() => setShowUserInfoPanel(true)}>
                            <Badge color="primary" badgeContent={currentUserList && currentUserList.length}><PeopleIcon/></Badge>
                        </IconButton>
                        {
                            showGreetBtn
                                ? <IconButton sx={{color: 'white'}} className="greet" onClick={() => setShowGreetBtn(false)}><ChatIcon/></IconButton>
                                : <div className="greet">
                                    <Input type="text" placeholder="说点什么吧" inputRef={greetMsgRef} />
                                    <IconButton
                                        sx={{color: 'white'}}
                                        onClick={() => {
                                            liveBroadcast({
                                                event_id: 'greet',
                                                message: greetMsgRef.current?.value
                                            })
                                            setShowGreetBtn(true)
                                        }}
                                    ><SendIcon /></IconButton>
                                </div>
                        }
                        <IconButton sx={{color: 'white'}} className="micro" onClick={() => toggleMicro(!selfInfo.micro_status)}>
                            { selfInfo?.micro_status ? (isTalking ? <MicIcon color='primary'/> : <MicIcon />) : <MicOffIcon/> }
                        </IconButton>
                        <IconButton sx={{color: 'white'}} className="close" onClick={handleClose}><CallEndIcon/></IconButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default DefaultSpaceLiveModeLayout;
